<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-kontrak" lazy-validation>
        <h2 style="margin: 0% auto;"><b>Kontrak Baru</b></h2>
        <h5>Kontrak > Tambahkan Kontrak</h5>
        <v-layout row wrap>

          <!-- Bagian Umum -->
          <v-flex xs6>
            <v-subheader><h4><b>Bagian Umum</b></h4></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-tag" label="Kode Penjualan" name="kodePenjualan" v-model="kodePenjualan" maxlength="9">
            </v-text-field>
            <small v-if="!isKodePenjualan" class="alert">Kode Penjual harus 9 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-apple-alt" label="Komoditas" name="komoditas" v-model="komoditas">
            </v-text-field>
            <small v-if="!isKomoditas" class="alert">Masukan Nama Komoditas</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-file"
              v-model="dokumen"
              :items="tipeDocs"
              label="Dokumen yang Dimiliki"
            ></v-select>
            <small v-if="!isDokumen" class="alert">Pilih Tipe Dokumen</small>
          </v-flex>

          <v-flex v-if="dokumen === 'Dokumen Usaha Dagang Perantara'" lg12 sm12>
            <v-text-field label="Upload Dokumen Usaha Dagang Perantara" @click='pickFileDokumenUsahaDagangPerantara' v-model='dokumenUsahaDagangPerantaraName' prepend-icon='upload_file'></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image"
              accept="*"
              @change="onFilePickedDokumenUsahaDagangPerantara"
            >
          </v-flex>

          <!-- Pelaku Usaha -->
          <v-flex xs6>
            <v-subheader><h4><b>Pelaku Usaha</b></h4></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="person" label="Nama Penjual" name="penjual" v-model="penjual">
            </v-text-field>
            <small v-if="!isPenjual" class="alert">Nama Penjual Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-building" label="Nama Perusahaan (Entitas)" name="entitasPenjual" v-model="entitasPenjual">
            </v-text-field>
            <small v-if="!isEntitasPenjual" class="alert">Masukan Nama Perusahaan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="phone" label="Kontak Penjual" name="kontakPenjual" v-model="kontakPenjual" type="number">
            </v-text-field>
            <small v-if="!isKontakPenjual" class="alert">Masukan Kontak Penjual</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="email" label="Email (Opsional)" name="emailPenjual" v-model="emailPenjual" type="email">
            </v-text-field>
            <small v-if="!isEmailPenjual" class="alert">Masukan Email Penjual (Opsional)</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-fax" label="Fax Penjual (Opsional)" name="faxPenjual" v-model="faxPenjual" type="number">
            </v-text-field>
            <small v-if="!isFaxPenjual" class="alert">Masukan Fax Penjual (Opsional)</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Jalan" name="alamatJalanPenjual" v-model="alamatJalanPenjual" type="text">
            </v-text-field>
            <small v-if="!isAlamatJalanPenjual" class="alert">Masukan Jalan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kelurahan" name="alamatKelurahanPenjual" v-model="alamatKelurahanPenjual" type="text">
            </v-text-field>
            <small v-if="!isAlamatKelurahanPenjual" class="alert">Masukan Kelurahan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kecamatan" name="alamatKecamatanPenjual" v-model="alamatKecamatanPenjual" type="text">
            </v-text-field>
            <small v-if="!isAlamatKecamatanPenjual" class="alert">Masukan Kecamatan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kabupaten / Kota" name="alamatKabupatenPenjual" v-model="alamatKabupatenPenjual" type="text">
            </v-text-field>
            <small v-if="!isAlamatKabupatenPenjual" class="alert">Masukan Kabupaten / Kota</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-map-marked-alt"
              v-model="alamatProvinsiPenjual"
              :items="tipeProvinsiPenjual"
              label="Pilih Provinsi"
            ></v-select>
            <small v-if="!isAlamatProvinsiPenjual" class="alert">Pilih Provinsi</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kode Pos" name="alamatKodePosPenjual" v-model="alamatKodePosPenjual" type="text" maxlength="6">
            </v-text-field>
            <small v-if="!isAlamatKodePosPenjual" class="alert">Masukan Kode Pos</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="person" label="Nama Pembeli" name="pembeli" v-model="pembeli">
            </v-text-field>
            <small v-if="!isPembeli" class="alert">Nama Pembeli Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-building" label="Nama Perusahaan (Entitas)" name="entitasPembeli" v-model="entitasPembeli">
            </v-text-field>
            <small v-if="!isEntitasPembeli" class="alert">Masukan Nama Perusahaan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="phone" label="Kontak Pembeli" name="kontakPembeli" v-model="kontakPembeli" type="number">
            </v-text-field>
            <small v-if="!isKontakPembeli" class="alert">Masukan Kontak Pembeli</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="email" label="Email (Opsional)" name="emailPembeli" v-model="emailPembeli" type="email">
            </v-text-field>
            <small v-if="!isEmailPembeli" class="alert">Masukan Email Pembeli (Opsional)</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-fax" label="Fax Pembeli (Opsional)" name="faxPembeli" v-model="faxPembeli" type="number">
            </v-text-field>
            <small v-if="!isFaxPembeli" class="alert">Masukan Fax Pembeli (Opsional)</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Jalan" name="alamatJalanPenjual" v-model="alamatJalanPembeli" type="text">
            </v-text-field>
            <small v-if="!isAlamatJalanPembeli" class="alert">Masukan Jalan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kelurahan" name="alamatKelurahanPenjual" v-model="alamatKelurahanPembeli" type="text">
            </v-text-field>
            <small v-if="!isAlamatKelurahanPembeli" class="alert">Masukan Kelurahan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kecamatan" name="alamatKecamatanPembeli" v-model="alamatKecamatanPembeli" type="text">
            </v-text-field>
            <small v-if="!isAlamatKecamatanPembeli" class="alert">Masukan Kecamatan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kabupaten / Kota" name="alamatKabupatenPembeli" v-model="alamatKabupatenPembeli" type="text">
            </v-text-field>
            <small v-if="!isAlamatKabupatenPembeli" class="alert">Masukan Kabupaten / Kota</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-map-marked-alt"
              v-model="alamatProvinsiPembeli"
              :items="tipeProvinsiPembeli"
              label="Pilih Provinsi"
            ></v-select>
            <small v-if="!isAlamatProvinsiPembeli" class="alert">Pilih Provinsi</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kode Pos" name="alamatKodePosPembeli" v-model="alamatKodePosPembeli" type="text" maxlength="6">
            </v-text-field>
            <small v-if="!isAlamatKodePosPembeli" class="alert">Masukan Kode Pos</small>
          </v-flex>

          <!-- Penjelasan Kontrak -->
          <v-flex xs6>
            <v-subheader><h4><b>Penjelasan Kontrak</b></h4></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-file-contract"
              v-model="jenisKontrak"
              :items="tipeKontrak"
              label="Tipe Kontrak"
            ></v-select>
            <small v-if="!isJenisKontrak" class="alert">Pilih Jenis Kontrak</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-balance-scale" label="Kuantitas" name="kuantitas" v-model="kuantitas" type="number">
            </v-text-field>
            <small v-if="!isKuantitas" class="alert">Masukan Kuantitas</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-balance-scale"
              v-model="unitKuantitas"
              :items="tipeUnitKuantitas"
              label="Pilih Unit Kuantitas"
            ></v-select>
            <small v-if="!isUnitKuantitas" class="alert">Pilih Jenis Unit Kuantitas</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-balance-scale"
              v-model="kualitas"
              :items="tipeKualitas"
              label="Pilih Kualitas"
            ></v-select>
            <small v-if="!isKualitas" class="alert">Pilih Jenis Kualitas</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-money" label="Harga Komoditas" name="hargakomoditas" v-model="hargaKomoditas" :suffix="'/' + unitKuantitas" type="number">
            </v-text-field>
            <small v-if="!isHargaKomoditas" class="alert">Masukan Harga Komoditas. Misal: 500000</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-hand-holding-usd"
              v-model="tempatPembayaran"
              :items="tipeTempatPembayaran"
              label="Pilih Tempat Pembayaran"
            ></v-select>
            <small v-if="!isTempatPembayaran" class="alert">Pilih Tempat Pembayaran</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-calendar" label="Musim" name="musim" v-model="musim" type="text">
            </v-text-field>
            <small v-if="!isMusim" class="alert">Masukan Musim. Misal: 19/20 (Tahun/Tahun)</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-road" label="Jalur Pengiriman" name="jalurPengiriman" v-model="jalurPengiriman">
            </v-text-field>
            <small v-if="!isJalurPengiriman" class="alert">Masukan Jalur Pengiriman</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-credit-card"
              v-model="skalaPembayaran"
              :items="tipeSkalaPembayaran"
              label="Skala Pembayaran"
            ></v-select>
            <small v-if="!isSkalaPembayaran" class="alert">Pilih Skala Pembayaran</small>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              ref="batasTanggalPembayaran"
              lazy
              class="pr-2"
              :close-on-content-click="false"
              v-model="batasTanggalPembayaranMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              min-width="290px"
              :return-value.sync="batasTanggalPembayaran"
            >
              <v-text-field
                slot="activator"
                label="Batas Tanggal Akhir Pembayaran"
                v-model="batasTanggalPembayaran"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="batasTanggalPembayaran" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="batasTanggalPembayaranMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.batasTanggalPembayaran.save(batasTanggalPembayaran)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <small v-if="!isBatasTanggalPembayaran" class="alert">Masukan Batas Tanggal Pembayaran</small>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              ref="batasWaktuPembayaran"
              lazy
              :close-on-content-click="false"
              v-model="batasWaktuPembayaranMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-24"
              max-width="290px"
              :return-value.sync="batasWaktuPembayaran"
            >
              <v-text-field
                slot="activator"
                label="Batas Waktu Akhir Pembayaran"
                v-model="batasWaktuPembayaran"
                prepend-icon="access_time"
                readonly
              ></v-text-field>
              <v-time-picker v-model="batasWaktuPembayaran" >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="batasWaktuPembayaranMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.batasWaktuPembayaran.save(batasWaktuPembayaran)">OK</v-btn>                
              </v-time-picker>
            </v-menu>
            <small>Untuk Pagi Hari Pilih <b>AM</b> dan Siang Hari Pilih <b>PM</b></small>
            <br>
            <small v-if="!isBatasWaktuPembayaran" class="alert">Masukan Batas Waktu Pembayaran</small>
          </v-flex> 

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-clock" label="Toleransi Keterlambatan" name="toleransi" v-model="toleransi" suffix="Hari" type="number">
            </v-text-field>
            <small v-if="!isToleransi" class="alert">Masukan Toleransi Keterlambatan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Daerah Pemasaran" name="daerahPemasaran" v-model="daerahPemasaran">
            </v-text-field>
            <small v-if="!isDaerahPemasaran" class="alert">Masukan Daerah Pemasaran</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-map-marked-alt"
              v-model="provinsiPemasaran"
              :items="tipeProvinsiPemasaran"
              label="Pilih Provinsi Pemasaran"
            ></v-select>
            <small v-if="!isProvinsiPemasaran" class="alert">Pilih Provinsi Pemasaran</small>
          </v-flex>

          <!-- Rincian Pengiriman -->
          <v-flex xs12>
            <v-subheader><h4><b>Rincian Pengiriman</b></h4></v-subheader>
          </v-flex>

          <v-flex xs12>
            <v-subheader><h5><b>Alamat Pengirim</b></h5></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="person" label="Nama Pengirim" name="pengirim" v-model="pengirim">
            </v-text-field>
            <small v-if="!isPengirim" class="alert">Nama Pengirim Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marker-alt" label="Lokasi Penjemputan (Nama Instansi)" name="lokasiPenjemputan" v-model="lokasiPenjemputan">
            </v-text-field>
            <small v-if="!isLokasiPenjemputan" class="alert">Masukan Lokasi Penjemputan Barang</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="phone" label="Kontak Pengirim" name="kontakPengirim" v-model="kontakPengirim" type="number">
            </v-text-field>
            <small v-if="!isKontakPengirim" class="alert">Masukan Kontak Pengirim</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Jalan" name="alamatJalanPenjemputan" v-model="alamatJalanPenjemputan">
            </v-text-field>
            <small v-if="!isAlamatJalanPenjemputan" class="alert">Masukan Jalan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kelurahan" name="alamatKelurahanPenjemputan" v-model="alamatKelurahanPenjemputan">
            </v-text-field>
            <small v-if="!isAlamatKelurahanPenjemputan" class="alert">Masukan Kelurahan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kecamatan" name="alamatKecamatanPenjemputan" v-model="alamatKecamatanPenjemputan">
            </v-text-field>
            <small v-if="!isAlamatKecamatanPenjemputan" class="alert">Masukan Kecamatan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kabupaten / Kota" name="alamatKabupatenPenjemputan" v-model="alamatKabupatenPenjemputan">
            </v-text-field>
            <small v-if="!isAlamatKabupatenPenjemputan" class="alert">Masukan Kabupaten / Kota</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-map-marked-alt"
              v-model="alamatProvinsiPenjemputan"
              :items="tipeProvinsiPenjemputan"
              label="Pilih Provinsi"
            ></v-select>
            <small v-if="!isAlamatProvinsiPenjemputan" class="alert">Pilih Provinsi</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kode Pos" name="alamatKodePosPenjemputan" v-model="alamatKodePosPenjemputan" maxlength="6">
            </v-text-field>
            <small v-if="!isAlamatKodePosPenjemputan" class="alert">Masukan Kode Pos</small>
          </v-flex>

          <v-flex xs12>
            <v-subheader><h5><b>Alamat Penerima</b></h5></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="person" label="Nama Penerima" name="penerima" v-model="penerima">
            </v-text-field>
            <small v-if="!isPenerima" class="alert">Nama Penerima Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marker-alt" label="Lokasi Pengiriman (Nama Instansi)" name="lokasiPengiriman" v-model="lokasiPengiriman">
            </v-text-field>
            <small v-if="!isLokasiPengiriman" class="alert">Masukan Lokasi Pengiriman Barang</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="phone" label="Kontak Penerima" name="kontakPenerima" v-model="kontakPenerima" type="number">
            </v-text-field>
            <small v-if="!isKontakPenerima" class="alert">Masukan Kontak Penerima</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Jalan" name="alamatJalanPengiriman" v-model="alamatJalanPengiriman">
            </v-text-field>
            <small v-if="!isAlamatJalanPengiriman" class="alert">Masukan Jalan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kelurahan" name="alamatKelurahanPengiriman" v-model="alamatKelurahanPengiriman">
            </v-text-field>
            <small v-if="!isAlamatKelurahanPengiriman" class="alert">Masukan kelurahan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kecamatan" name="alamatKecamatanPengiriman" v-model="alamatKecamatanPengiriman">
            </v-text-field>
            <small v-if="!isAlamatKecamatanPengiriman" class="alert">Masukan Kecamatan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kabupaten / Kota" name="alamatKabupatenPengiriman" v-model="alamatKabupatenPengiriman">
            </v-text-field>
            <small v-if="!isAlamatKabupatenPengiriman" class="alert">Masukan Kabupaten / Kota</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-map-marked-alt"
              v-model="alamatProvinsiPengiriman"
              :items="tipeProvinsiPengiriman"
              label="Pilih Provinsi"
            ></v-select>
            <small v-if="!isAlamatProvinsiPengiriman" class="alert">Pilih Provinsi</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kode Pos" name="alamatKodePosPengiriman" v-model="alamatKodePosPengiriman" maxlength="6">
            </v-text-field>
            <small v-if="!isAlamatKodePosPengiriman" class="alert">Masukan Kode Pos</small>
          </v-flex>

          <!-- Detail Pengiriman -->
          <v-flex xs12>
            <v-subheader><h4><b>Detail Pengiriman</b></h4></v-subheader>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              class="pr-2"
              ref="tanggalMulaiPengiriman"
              lazy
              :close-on-content-click="false"
              v-model="tanggalMulaiPengirimanMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              max-width="290px"
              :return-value.sync="tanggalMulaiPengiriman"
            >
              <v-text-field
                slot="activator"
                label="Tanggal Mulai Pengiriman"
                v-model="tanggalMulaiPengiriman"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="tanggalMulaiPengiriman" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="tanggalMulaiPengirimanMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.tanggalMulaiPengiriman.save(tanggalMulaiPengiriman)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <small v-if="!isTanggalMulaiPengiriman" class="alert">Pilih Tanggal Mulai Pengiriman</small>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              ref="waktuMulaiPengiriman"
              lazy
              :close-on-content-click="false"
              v-model="waktuMulaiPengirimanMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-24"
              max-width="290px"
              :return-value.sync="waktuMulaiPengiriman"
            >
              <v-text-field
                slot="activator"
                label="Waktu Mulai Pengiriman"
                v-model="waktuMulaiPengiriman"
                prepend-icon="access_time"
                readonly
              ></v-text-field>
              <v-time-picker v-model="waktuMulaiPengiriman">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="waktuMulaiPengirimanMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.waktuMulaiPengiriman.save(waktuMulaiPengiriman)">OK</v-btn>                
              </v-time-picker>
            </v-menu>
            <small>Untuk Pagi Hari Pilih <b>AM</b> dan Siang Hari Pilih <b>PM</b></small>
            <br>
            <small v-if="!isWaktuMulaiPengiriman" class="alert">Pilih Waktu Mulai Pengiriman</small>
          </v-flex> 

          <v-flex sm6 lg6>
            <v-menu
              ref="tanggalBerakhirPengiriman"
              lazy
              class="pr-2"
              :close-on-content-click="false"
              v-model="tanggalBerakhirPengirimanMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              min-width="290px"
              :return-value.sync="tanggalBerakhirPengiriman"
            >
              <v-text-field
                slot="activator"
                label="Tanggal Berakhir Pengiriman"
                v-model="tanggalBerakhirPengiriman"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="tanggalBerakhirPengiriman" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="tanggalBerakhirPengirimanMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.tanggalBerakhirPengiriman.save(tanggalBerakhirPengiriman)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <small v-if="!isTanggalBerakhirPengiriman" class="alert">Pilih Tanggal Berakhir Pengiriman</small>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              ref="waktuBerakhirPengiriman"
              lazy
              :close-on-content-click="false"
              v-model="waktuBerakhirPengirimanMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-24"
              max-width="290px"
              :return-value.sync="waktuBerakhirPengiriman"
            >
              <v-text-field
                slot="activator"
                label="Waktu Berakhir Pengiriman"
                v-model="waktuBerakhirPengiriman"
                prepend-icon="access_time"
                readonly
              ></v-text-field>
              <v-time-picker v-model="waktuBerakhirPengiriman" >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="waktuBerakhirPengirimanMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.waktuBerakhirPengiriman.save(waktuBerakhirPengiriman)">OK</v-btn>                
              </v-time-picker>
            </v-menu>
            <small>Untuk Pagi Hari Pilih <b>AM</b> dan Siang Hari Pilih <b>PM</b></small>
            <br>
            <small v-if="!isWaktuBerakhirPengiriman" class="alert">Pilih Waktu Berakhir Pengiriman</small>
          </v-flex> 

          <!-- Penjelasan Barang -->
          <v-flex xs12>
            <v-subheader><h4><b>Penjelasan Barang</b></h4></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-box" label="Jenis Pengepakan" name="jenisPengepakan" v-model="jenisPengepakan">
            </v-text-field>
            <small v-if="!isJenisPengepakan" class="alert">Masukan Jenis Pengepakan. Contoh: Box, Kotak, Ikat, dll.</small>
          </v-flex>

          <!-- Kondisi Kontrak -->
          <v-flex xs12>
            <v-subheader><h4><b>Kondisi Kontrak</b></h4></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-textarea prepend-icon="fas fa-file-contract" label="Kondisi Kontrak Umum (Opsional)" name="kondisiUmum" v-model="kondisiUmum" outline>
            </v-textarea>
            <small v-if="!isKondisiUmum" class="alert">Masukan Kondisi Umum (Opsional)</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-textarea prepend-icon="fas fa-file-contract" label="Kondisi Kontrak Khusus (Opsional)" name="kondisiKhusus" v-model="kondisiKhusus" outline>
            </v-textarea>
            <small v-if="!isKondisiKhusus" class="alert">Masukan Kondisi Khusus (Opsional)</small>
          </v-flex>

          <!-- Penilaian Kontrak -->
          <v-flex xs12>
            <v-subheader><h4><b>Penilaian Kontrak</b></h4></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-money" label="Nilai Kontrak" name="nilai" v-model="nilai" prefix="Rp. " suffix=".00" type="Number">
            </v-text-field>
            <small v-if="!isNilai" class="alert">Masukan Nilai Kontrak. Contoh: 1000000</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-money" label="Maksimal Nilai Kontrak" name="maxNilai" v-model="maxNilai" prefix="Rp. " suffix=".00" type="Number">
            </v-text-field>
            <small v-if="!isMaxNilai" class="alert">Masukan Maksimal Nilai Kontrak. Contoh: 10000000</small>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              ref="tanggalJatuhTempo"
              lazy
              class="pr-2"
              :close-on-content-click="false"
              v-model="tanggalJatuhTempoMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              min-width="290px"
              :return-value.sync="tanggalJatuhTempo"
            >
              <v-text-field
                slot="activator"
                label="Perkiraan Tanggal Jatuh Tempo Pembayaran"
                v-model="tanggalJatuhTempo"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="tanggalJatuhTempo" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="tanggalJatuhTempoMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.tanggalJatuhTempo.save(tanggalJatuhTempo)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <small v-if="!isTanggalJatuhTempo" class="alert">Pilih Tanggal Jatuh Tempo Pembayaran Kontrak</small>
          </v-flex>

          <v-flex sm6 lg6>
            <v-menu
              ref="waktuJatuhTempo"
              lazy
              :close-on-content-click="false"
              v-model="waktuJatuhTempoMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-24"
              max-width="290px"
              :return-value.sync="waktuJatuhTempo"
            >
              <v-text-field
                slot="activator"
                label="Perkiraan Waktu Jatuh Tempo Pembayaran"
                v-model="waktuJatuhTempo"
                prepend-icon="access_time"
                readonly
              ></v-text-field>
              <v-time-picker v-model="waktuJatuhTempo" >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="waktuJatuhTempoMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.waktuJatuhTempo.save(waktuJatuhTempo)">OK</v-btn>                
              </v-time-picker>
            </v-menu>
            <small>Untuk Pagi Hari Pilih <b>AM</b> dan Siang Hari Pilih <b>PM</b></small>
            <br>
            <small v-if="!isWaktuJatuhTempo" class="alert">Pilih Waktu Jatuh Tempo Pembayaran Kontrak</small>
          </v-flex> 

          <!-- Usaha Pedagang Perantara -->
          <v-flex xs12>
            <v-subheader><h4><b>Usaha Pedagang Perantara</b></h4></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-hand-holding-usd"
              v-model="jenisPembayaran"
              :items="tipePembayaran"
              label="Pilih Tipe Pembayaran"
            ></v-select>
            <small v-if="!isJenisPembayaran" class="alert">Pilih Jenis Pembayaran</small>
          </v-flex>

          <!-- Administrasi -->
          <v-flex xs12>
            <v-subheader><h4><b>Administrasi</b></h4></v-subheader>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-receipt" label="Invoicing" name="invoicing" v-model="invoicing" disabled>
            </v-text-field>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="person" label="Nama Perantara" name="perantara" v-model="perantara">
            </v-text-field>
            <small v-if="!isPerantara" class="alert">Nama Perantara Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-building" label="Nama Instansi Perantara (Entitas)" name="entitasPerantara" v-model="entitasPerantara">
            </v-text-field>
            <small v-if="!isEntitasPerantara" class="alert">Masukan Nama Instansi</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="phone" label="Kontak Perantara" name="kontakPerantara" v-model="kontakPerantara" type="number">
            </v-text-field>
            <small v-if="!isKontakPerantara" class="alert">Masukan Kontak Perantara</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-textarea prepend-icon="fas fa-comment-dots" label="Catatan Pedagang (Opsional)" name="catatanPedagang" v-model="catatanPedagang" outline>
            </v-textarea>
            <small v-if="!isCatatanPedagang" class="alert">Masukan Catatan Pedagang (Opsional)</small>
          </v-flex>

          <v-flex lg12 sm12>
            <p>Email PDF Copy to</p>
            <v-layout row wrap>
              <v-checkbox v-model="selectedPDF" label="Broker" value="Broker" row></v-checkbox>
              <v-checkbox v-model="selectedPDF" label="Seller" value="Seller" row></v-checkbox>
              <v-checkbox v-model="selectedPDF" label="Buyer" value="Buyer" row></v-checkbox>
            </v-layout>
          </v-flex>

        </v-layout>        

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="back">Batal</v-btn>
          <v-btn color="secondary" @click="saveTemplate">Simpan Template</v-btn>
          <v-btn color="primary" form="tambahkan-kontrak" @click="getKontrak" :disabled="!isComplete">Lanjutkan dan Ulas</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  components: {
  },
  data: () => ({
    valid: true,
    date: '',
    modal: false ,

    // Bagian Umum 
    kodePenjualan: '',
    komoditas: '',
    dokumen: '',
    dokumenUsahaDagangPerantaraName: '',
		dokumenUsahaDagangPerantaraUrl: '',
    dokumenUsahaDagangPerantaraImage: '',

    // Pelaku Usaha
    penjual: '',
    entitasPenjual: '',
    kontakPenjual: '',
    emailPenjual: '',
    faxPenjual: '',
    alamatJalanPenjual: '',
    alamatKelurahanPenjual: '',
    alamatKecamatanPenjual: '',
    alamatKabupatenPenjual: '',
    alamatKotaPenjual: '',
    alamatProvinsiPenjual: '',
    tipeProvinsiPenjual: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  
    alamatKodePosPenjual: '',

    pembeli: '',
    entitasPembeli: '',
    kontakPembeli: '',
    emailPembeli: '',
    faxPembeli: '',
    alamatJalanPembeli: '',
    alamatKelurahanPembeli: '',
    alamatKecamatanPembeli: '',
    alamatKabupatenPembeli: '',
    alamatKotaPembeli: '',
    alamatProvinsiPembeli: '',
    tipeProvinsiPembeli: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  
    alamatKodePosPembeli: '',

    // Penjelasan Kontrak
    jenisKontrak: '',
    tipeKontrak: [
      'Permanen',
      'Sementara',
      'Multipihak',
    ], 
    kuantitas: '',
    unitKuantitas: '',
    kualitas: '',
    tipeKualitas: [
      'Bagus',
      'Sedang',
    ], 
    hargaKomoditas: '',
    tempatPembayaran: '',
    tipeTempatPembayaran: [
      'Lahan/Toko',
      'Lokasi Penerimaan Barang',
      'Tempat Pembeli',
    ], 
    musim: '',
    jalurPengiriman: '',
    skalaPembayaran: '',
    tipeSkalaPembayaran: [
      'Kredit',
      'Tunai',
    ], 
    batasTanggalPembayaranMenu: false,
    batasTanggalPembayaran: '',
    batasWaktuPembayaranMenu: false,
    batasWaktuPembayaran: '',
    toleransi: '',
    daerahPemasaran: '',
    provinsiPemasaran: '',
    tipeProvinsiPemasaran: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  

    // Rincian Pengiriman
    pengirim: '',
    kontakPengirim: '',
    tipeProvinsiPenjemputan: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  

    penerima: '',
    kontakPenerima: '',
    tipeProvinsiPengiriman: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  

    // Detail Pengiriman
    tanggalMulaiPengirimanMenu: false,
    tanggalMulaiPengiriman: '',
    waktuMulaiPengirimanMenu: false,
    waktuMulaiPengiriman: '',
    tanggalBerakhirPengirimanMenu: false,
    tanggalBerakhirPengiriman: '',
    waktuBerakhirPengirimanMenu: false,
    waktuBerakhirPengiriman: '',

    // Penjelasan Barang
    jenisPengepakan: '',

    // Kondisi Kontrak
    kondisiUmum: '',
    kondisiKhusus: '',

    // Penilaian Kontrak
    nilai: '',
    maxNilai: '',
    tanggalJatuhTempoMenu: false,
    tanggalJatuhTempo: '',
    waktuJatuhTempoMenu: false,
    waktuJatuhTempo: '',

    // Usaha Pedagang Perantara
    jenisPembayaran: '',
    tipePembayaran: [
      'Penjual',
      'Pembeli',
      'Pembeli dan Penjual'
    ], 

    // Administrasi
    invoicing: 'Broker to Invoice Buyer',
    perantara: '',
    catatanPedagang: '',

    selectedPDF: [],

    // Form Check
    reg: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
    regMusim: /^[0-9]+\/+[0-9]+/,

  }),

  computed: {
    tipeDocs() {
      return [
        'Dokumen Usaha Dagang Perantara',
        this.kodePenjualan
      ]
    },
    tipeUnitKuantitas() {
      return [
        'Kg',
        'Ton',
        'm3',
      ] 
    },
    lokasiPenjemputan(){
      return this.entitasPenjual
    },
    alamatJalanPenjemputan(){
      return this.alamatJalanPenjual
    },
    alamatKelurahanPenjemputan(){
      return this.alamatKelurahanPenjual
    },
    alamatKecamatanPenjemputan(){
      return this.alamatKecamatanPenjual
    },
    alamatKabupatenPenjemputan(){
      return this.alamatKabupatenPenjual
    },
    alamatProvinsiPenjemputan(){
      return this.alamatProvinsiPenjual
    },
    alamatKodePosPenjemputan(){
      return this.alamatKodePosPenjual
    },
    lokasiPengiriman(){
      return this.entitasPembeli
    },
    alamatJalanPengiriman(){
      return this.alamatJalanPembeli
    },
    alamatKelurahanPengiriman(){
      return this.alamatKelurahanPembeli
    },
    alamatKecamatanPengiriman(){
      return this.alamatKecamatanPembeli
    },
    alamatKabupatenPengiriman(){
      return this.alamatKabupatenPembeli
    },
    alamatProvinsiPengiriman(){
      return this.alamatProvinsiPembeli
    },
    alamatKodePosPengiriman(){
      return this.alamatKodePosPembeli
    },
    entitasPerantara(){
      return this.entitasPembeli
    },
    kontakPerantara(){
      return this.kontakPengirim
    },



    // Form Check

    isComplete(){
      return (this.kodePenjualan && this.kodePenjualan.length == 9) && (this.komoditas) && (this.dokumen) && (this.penjual && this.penjual.length >= 3) && (this.entitasPenjual) && (this.kontakPenjual && this.kontakPenjual >= 0 && this.kontakPenjual.length >= 8) && (this.alamatJalanPenjual) && (this.alamatKelurahanPenjual) && (this.alamatKecamatanPenjual) && (this.alamatKabupatenPenjual) && (this.alamatProvinsiPenjual) && (this.alamatKodePosPenjual) && (this.pembeli && this.pembeli.length >= 3) && (this.entitasPembeli) && (this.kontakPembeli && this.kontakPembeli >= 0 && this.kontakPembeli.length >= 8) && (this.alamatJalanPembeli) && (this.alamatKelurahanPembeli) && (this.alamatKecamatanPembeli) && (this.alamatKabupatenPembeli) && (this.alamatProvinsiPembeli) && (this.alamatKodePosPembeli) && (this.jenisKontrak) && (this.kuantitas && this.kuantitas >= 1) && (this.unitKuantitas) && (this.kualitas) && (this.hargaKomoditas && this.hargaKomoditas >= 0) && (this.tempatPembayaran) && (this.musim && this.regMusim.test(this.musim) && this.musim.length <= 5) && (this.jalurPengiriman) && (this.skalaPembayaran) && (this.batasTanggalPembayaran) && (this.batasWaktuPembayaran) && (this.toleransi && this.toleransi >= 0) && (this.daerahPemasaran) && (this.provinsiPemasaran) && (this.pengirim && this.pengirim.length >= 3) && (this.lokasiPenjemputan) && (this.kontakPengirim && this.kontakPengirim >= 0 && this.kontakPengirim >= 8) && (this.alamatJalanPenjemputan) && (this.alamatKelurahanPenjemputan) && (this.alamatKecamatanPenjemputan) && (this.alamatKabupatenPenjemputan) && (this.alamatProvinsiPenjemputan) && (this.alamatKodePosPenjemputan) && (this.penerima && this.penerima.length >= 3) && (this.lokasiPengiriman) && (this.kontakPenerima && this.kontakPenerima >= 0 && this.kontakPenerima.length >= 8) && (this.alamatJalanPengiriman) && (this.alamatKelurahanPengiriman) && (this.alamatKecamatanPengiriman) && (this.alamatKabupatenPengiriman) && (this.alamatProvinsiPengiriman) && (this.alamatKodePosPengiriman) && (this.tanggalMulaiPengiriman) && (this.waktuMulaiPengiriman) && (this.tanggalBerakhirPengiriman) && (this.waktuBerakhirPengiriman) && (this.jenisPengepakan) && (this.nilai && this.nilai >= 0) && (this.maxNilai && this.maxNilai >= 0) && (this.tanggalJatuhTempo) && (this.waktuJatuhTempo) && (this.jenisPembayaran) && (this.perantara && this.perantara.length >= 3) && (this.entitasPerantara) && (this.kontakPerantara && this.kontakPerantara >= 0 && this.kontakPerantara.length >= 8);
    },

    // Bagian Umum

    isKodePenjualan(){
      return (this.kodePenjualan && this.kodePenjualan.length == 9);
    },

    isKomoditas(){
      return (this.komoditas);
    },

    isDokumen(){
      return (this.dokumen);
    },

    // Pelaku Usaha

    isPenjual(){
      return (this.penjual && this.penjual.length >= 3);
    },

    isEntitasPenjual(){
      return (this.entitasPenjual);
    },

    isKontakPenjual(){
      return (this.kontakPenjual && this.kontakPenjual >= 0 && this.kontakPenjual.length >= 8);
    },

    isEmailPenjual () {
      return (this.emailPenjual && this.reg.test(this.emailPenjual));
    },

    isFaxPenjual(){
      return (this.faxPenjual && this.faxPenjual >= 0 && this.faxPenjual.length >= 8);
    },

    isAlamatJalanPenjual(){
      return (this.alamatJalanPenjual);
    },

    isAlamatKelurahanPenjual(){
      return (this.alamatKelurahanPenjual);
    },

    isAlamatKecamatanPenjual(){
      return (this.alamatKecamatanPenjual);
    },

    isAlamatKabupatenPenjual(){
      return (this.alamatKabupatenPenjual);
    },

    isAlamatProvinsiPenjual(){
      return (this.alamatProvinsiPenjual);
    },

    isAlamatKodePosPenjual(){
      return (this.alamatKodePosPenjual);
    },

    isPembeli(){
      return (this.pembeli && this.pembeli.length >= 3);
    },

    isEntitasPembeli(){
      return (this.entitasPembeli);
    },

    isKontakPembeli(){
      return (this.kontakPembeli && this.kontakPembeli >= 0 && this.kontakPembeli.length >= 8);
    },

    isEmailPembeli () {
      return (this.emailPembeli && this.reg.test(this.emailPembeli));
    },

    isFaxPembeli(){
      return (this.faxPembeli && this.faxPembeli >= 0 && this.faxPembeli.length >= 8);
    },

    isAlamatJalanPembeli () {
      return (this.alamatJalanPembeli);
    },

    isAlamatKelurahanPembeli () {
      return (this.alamatKelurahanPembeli);
    },

    isAlamatKecamatanPembeli () {
      return (this.alamatKecamatanPembeli);
    },

    isAlamatKabupatenPembeli () {
      return (this.alamatKabupatenPembeli);
    },

    isAlamatProvinsiPembeli () {
      return (this.alamatProvinsiPembeli);
    },

    isAlamatKodePosPembeli () {
      return (this.alamatKodePosPembeli);
    },

    // Penjelasan Kontrak

    isJenisKontrak () {
      return (this.jenisKontrak);
    },

    isKuantitas () {
      return (this.kuantitas && this.kuantitas >= 1);
    },

    isUnitKuantitas () {
      return (this.unitKuantitas);
    },

    isKualitas () {
      return (this.kualitas);
    },

    isHargaKomoditas () {
      return (this.hargaKomoditas && this.hargaKomoditas >= 0);
    },

    isTempatPembayaran () {
      return (this.tempatPembayaran);
    },

    isMusim () {
      return (this.musim && this.regMusim.test(this.musim) && this.musim.length <= 5);
    },

    isJalurPengiriman () {
      return (this.jalurPengiriman);
    },

    isSkalaPembayaran () {
      return (this.skalaPembayaran);
    },

    isBatasTanggalPembayaran () {
      return (this.batasTanggalPembayaran);
    },

    isBatasWaktuPembayaran () {
      return (this.batasWaktuPembayaran);
    },

    isToleransi () {
      return (this.toleransi && this.toleransi >= 0);
    },

    isDaerahPemasaran () {
      return (this.daerahPemasaran);
    },

    isProvinsiPemasaran () {
      return (this.provinsiPemasaran);
    },

    // Rincian Pengiriman

    isPengirim () {
      return (this.pengirim && this.pengirim.length >= 3);
    },

    isLokasiPenjemputan () {
      return (this.lokasiPenjemputan);
    },

    isKontakPengirim () {
      return (this.kontakPengirim && this.kontakPengirim >= 0 && this.kontakPengirim.length >= 8);
    },

    isAlamatJalanPenjemputan () {
      return (this.alamatJalanPenjemputan);
    },

    isAlamatKelurahanPenjemputan () {
      return (this.alamatKelurahanPenjemputan);
    },

    isAlamatKecamatanPenjemputan () {
      return (this.alamatKecamatanPenjemputan);
    },

    isAlamatKabupatenPenjemputan () {
      return (this.alamatKabupatenPenjemputan);
    },

    isAlamatProvinsiPenjemputan () {
      return (this.alamatProvinsiPenjemputan);
    },

    isAlamatKodePosPenjemputan () {
      return (this.alamatKodePosPenjemputan);
    },

    isPenerima () {
      return (this.penerima && this.penerima.length >= 3);
    },

    isLokasiPengiriman () {
      return (this.lokasiPengiriman);
    },

    isKontakPenerima () {
      return (this.kontakPenerima && this.kontakPenerima >= 0 && this.kontakPenerima.length >= 8);
    },

    isAlamatJalanPengiriman () {
      return (this.alamatJalanPengiriman);
    },

    isAlamatKelurahanPengiriman () {
      return (this.alamatKelurahanPengiriman);
    },

    isAlamatKecamatanPengiriman () {
      return (this.alamatKecamatanPengiriman);
    },

    isAlamatKabupatenPengiriman () {
      return (this.alamatKabupatenPengiriman);
    },

    isAlamatProvinsiPengiriman () {
      return (this.alamatProvinsiPengiriman);
    },

    isAlamatKodePosPengiriman () {
      return (this.alamatKodePosPengiriman);
    },

    // Detail Pengiriman

    isTanggalMulaiPengiriman () {
      return (this.tanggalMulaiPengiriman);
    },

    isWaktuMulaiPengiriman () {
      return (this.waktuMulaiPengiriman);
    },

    isTanggalBerakhirPengiriman () {
      return (this.tanggalBerakhirPengiriman);
    },

    isWaktuBerakhirPengiriman () {
      return (this.waktuBerakhirPengiriman);
    },

    // Penjelasan Barang

    isJenisPengepakan () {
      return (this.jenisPengepakan);
    },

    // Kondisi Kontrak

    isKondisiUmum () {
      return (this.kondisiUmum);
    },

    isKondisiKhusus () {
      return (this.kondisiKhusus);
    },

    // Penilaian Kontrak

    isNilai () {
      return (this.nilai && this.nilai >= 0);
    },

    isMaxNilai () {
      return (this.maxNilai && this.maxNilai >= 0);
    },

    isTanggalJatuhTempo () {
      return (this.tanggalJatuhTempo);
    },

    isWaktuJatuhTempo () {
      return (this.waktuJatuhTempo);
    },

    // Usaha Pedagang Pertanian

    isJenisPembayaran () {
      return (this.jenisPembayaran);
    },

    // Administrasi

    isPerantara () {
      return (this.perantara && this.perantara.length >= 3);
    },

    isEntitasPerantara () {
      return (this.entitasPerantara);
    },

    isKontakPerantara () {
      return (this.kontakPerantara && this.kontakPerantara >= 0 && this.kontakPerantara.length >= 8);
    },

    isCatatanPedagang () {
      return (this.catatanPedagang);
    },

  },

  methods: {
    pickFileDokumenUsahaDagangPerantara () {
      this.$refs.image.click ()
    },
		
		onFilePickedDokumenUsahaDagangPerantara (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.dokumenUsahaDagangPerantaraName = files[0].name
				if(this.dokumenUsahaDagangPerantaraName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.dokumenUsahaDagangPerantaraUrl = fr.result
					this.dokumenUsahaDagangPerantaraImage = files[0] // this is an image file that can be sent to server...
				})
			} else {
				this.dokumenUsahaDagangPerantaraName = ''
				this.dokumenUsahaDagangPerantaraImage = ''
				this.dokumenUsahaDagangPerantaraUrl = ''
			}
		},

    closeDialog () {
      this.$parent.isActive = false;
    },

    back(){
      window.getApp.$emit('APP_KONTRAK');
      // return '/pemerintah';
    },

    saveTemplate(){
      // Bagian Umum
      localStorage.kontrakKodePenjualan = this.kodePenjualan,
      localStorage.kontrakKomoditas = this.komoditas,
      localStorage.kontrakDokumen = this.dokumen,

      // Pelaku Usaha
      localStorage.kontrakPenjual = this.penjual,
      localStorage.kontrakEntitasPenjual = this.entitasPenjual,
      localStorage.kontrakKontakPenjual = this.kontakPenjual,
      localStorage.kontrakEmailPenjual = this.emailPenjual,
      localStorage.kontrakFaxPenjual = this.faxPenjual,
      localStorage.kontrakAlamatJalanPenjual = this.alamatJalanPenjual,
      localStorage.kontrakAlamatKelurahanPenjual = this.alamatKelurahanPenjual,
      localStorage.kontrakAlamatKecamatanPenjual = this.alamatKecamatanPenjual,
      localStorage.kontrakAlamatKabupatenPenjual = this.alamatKabupatenPenjual,
      localStorage.kontrakAlamatKotaPenjual = this.alamatKotaPenjual,
      localStorage.kontrakAlamatProvinsiPenjual = this.alamatProvinsiPenjual,
      localStorage.kontrakAlamatKodePosPenjual = this.alamatKodePosPenjual,

      localStorage.kontrakPembeli = this.pembeli,
      localStorage.kontrakEntitasPembeli = this.entitasPembeli,
      localStorage.kontrakKontakPembeli = this.kontakPembeli,
      localStorage.kontrakEmailPembeli = this.emailPembeli,
      localStorage.kontrakFaxPembeli = this.faxPembeli,
      localStorage.kontrakAlamatJalanPembeli = this.alamatJalanPembeli,
      localStorage.kontrakAlamatKelurahanPembeli = this.alamatKelurahanPembeli,
      localStorage.kontrakAlamatKecamatanPembeli = this.alamatKecamatanPembeli,
      localStorage.kontrakAlamatKabupatenPembeli = this.alamatKabupatenPembeli,
      localStorage.kontrakAlamatKotaPembeli = this.alamatKotaPembeli,
      localStorage.kontrakAlamatProvinsiPembeli = this.alamatProvinsiPembeli,
      localStorage.kontrakAlamatKodePosPembeli = this.alamatKodePosPenjual,

      // Penjelasan Kontrak
      localStorage.kontrakJenisKontrak = this.jenisKontrak,
      localStorage.kontrakKuantitas = this.kuantitas,
      localStorage.kontrakUnitKuantitas = this.unitKuantitas,
      localStorage.kontrakKualitas = this.kualitas,
      localStorage.kontrakHargaKomoditas = this.hargaKomoditas,
      localStorage.kontrakTempatPembayaran = this.tempatPembayaran,
      localStorage.kontrakMusim = this.musim,
      localStorage.kontrakJalurPengiriman = this.jalurPengiriman,
      localStorage.kontrakSkalaPembayaran = this.skalaPembayaran,
      localStorage.kontrakBatasTanggalPembayaran = this.batasTanggalPembayaran,
      localStorage.kontrakBatasWaktuPembayaran = this.batasWaktuPembayaran,
      localStorage.kontrakToleransi = this.toleransi,
      localStorage.kontrakDaerahPemasaran = this.daerahPemasaran,
      localStorage.kontrakProvinsiPemasaran = this.provinsiPemasaran,

      // Rincian Pengiriman
      localStorage.kontrakPengirim = this.pengirim,
      localStorage.kontrakLokasiPenjemputan = this.lokasiPenjemputan,
      localStorage.kontrakKontakPengirim = this.kontakPengirim,
      localStorage.kontrakAlamatJalanPenjemputan = this.alamatJalanPenjemputan,
      localStorage.kontrakAlamatKelurahanPenjemputan = this.alamatKelurahanPenjemputan,
      localStorage.kontrakAlamatKecamatanPenjemputan = this.alamatKecamatanPenjemputan,
      localStorage.kontrakAlamatKabupatenPenjemputan = this.alamatKabupatenPenjemputan,
      localStorage.kontrakAlamatKotaPenjemputan = this.alamatKotaPenjemputan,
      localStorage.kontrakAlamatProvinsiPenjemputan = this.alamatProvinsiPenjemputan,
      localStorage.kontrakAlamatKodePosPenjemputan = this.alamatKodePosPenjemputan,

      localStorage.kontrakPenerima = this.penerima,
      localStorage.kontrakLokasiPengiriman = this.lokasiPengiriman,
      localStorage.kontrakKontakPenerima = this.kontakPenerima,
      localStorage.kontrakAlamatJalanPengiriman = this.alamatJalanPengiriman,
      localStorage.kontrakAlamatKelurahanPengiriman = this.alamatKelurahanPengiriman,
      localStorage.kontrakAlamatKecamatanPengiriman = this.alamatKecamatanPengiriman,
      localStorage.kontrakAlamatKabupatenPengiriman = this.alamatKabupatenPengiriman,
      localStorage.kontrakAlamatKotaPengiriman = this.alamatKotaPengiriman,
      localStorage.kontrakAlamatProvinsiPengiriman = this.alamatProvinsiPengiriman,
      localStorage.kontrakAlamatKodePosPengiriman = this.alamatKodePosPengiriman,


      // Detail Pengiriman
      localStorage.kontrakTanggalMulaiPengiriman = this.tanggalMulaiPengiriman,
      localStorage.kontrakWaktuMulaiPengiriman = this.waktuMulaiPengiriman,
      localStorage.kontrakTanggalBerakhirPengiriman = this.tanggalBerakhirPengiriman,
      localStorage.kontrakWaktuBerakhirPengiriman = this.waktuBerakhirPengiriman,

      // Penjelasan Barang
      localStorage.kontrakJenisPengepakan = this.jenisPengepakan,

      // Kondisi Kontrak
      localStorage.kontrakKondisiUmum = this.kondisiUmum,
      localStorage.kontrakKondisiKhusus = this.kondisiKhusus,

      // Penilaian Kontrak
      localStorage.kontrakNilai = this.nilai,
      localStorage.kontrakMaxNilai = this.maxNilai,
      localStorage.kontrakTanggalJatuhTempo = this.tanggalJatuhTempo,
      localStorage.kontrakWaktuJatuhTempo = this.waktuJatuhTempo,

      // Usaha Pedagang Perantara
      localStorage.kontrakJenisPembayaran = this.jenisPembayaran,

      // Administrasi
      localStorage.kontrakInvoicing = this.invoicing,
      localStorage.kontrakPerantara = this.perantara,
      localStorage.kontrakEntitasPerantara = this.entitasPerantara,
      localStorage.kontrakKontakPerantara = this.kontakPerantara,
      localStorage.kontrakCatatanPedagang = this.catatanPedagang

      window.getApp.$emit('APP_SIMPAN_TEMPLATE');
    },

    getKontrak (){
      // Bagian Umum
      localStorage.kontrakKodePenjualan = this.kodePenjualan,
      localStorage.kontrakKomoditas = this.komoditas,
      localStorage.kontrakDokumen = this.dokumen,

      // Pelaku Usaha
      localStorage.kontrakPenjual = this.penjual,
      localStorage.kontrakEntitasPenjual = this.entitasPenjual,
      localStorage.kontrakKontakPenjual = this.kontakPenjual,
      localStorage.kontrakEmailPenjual = this.emailPenjual,
      localStorage.kontrakFaxPenjual = this.faxPenjual,
      localStorage.kontrakAlamatJalanPenjual = this.alamatJalanPenjual,
      localStorage.kontrakAlamatKelurahanPenjual = this.alamatKelurahanPenjual,
      localStorage.kontrakAlamatKecamatanPenjual = this.alamatKecamatanPenjual,
      localStorage.kontrakAlamatKabupatenPenjual = this.alamatKabupatenPenjual,
      localStorage.kontrakAlamatKotaPenjual = this.alamatKotaPenjual,
      localStorage.kontrakAlamatProvinsiPenjual = this.alamatProvinsiPenjual,
      localStorage.kontrakAlamatKodePosPenjual = this.alamatKodePosPenjual,

      localStorage.kontrakPembeli = this.pembeli,
      localStorage.kontrakEntitasPembeli = this.entitasPembeli,
      localStorage.kontrakKontakPembeli = this.kontakPembeli,
      localStorage.kontrakEmailPembeli = this.emailPembeli,
      localStorage.kontrakFaxPembeli = this.faxPembeli,
      localStorage.kontrakAlamatJalanPembeli = this.alamatJalanPembeli,
      localStorage.kontrakAlamatKelurahanPembeli = this.alamatKelurahanPembeli,
      localStorage.kontrakAlamatKecamatanPembeli = this.alamatKecamatanPembeli,
      localStorage.kontrakAlamatKabupatenPembeli = this.alamatKabupatenPembeli,
      localStorage.kontrakAlamatKotaPembeli = this.alamatKotaPembeli,
      localStorage.kontrakAlamatProvinsiPembeli = this.alamatProvinsiPembeli,
      localStorage.kontrakAlamatKodePosPembeli = this.alamatKodePosPembeli,

      // Penjelasan Kontrak
      localStorage.kontrakJenisKontrak = this.jenisKontrak,
      localStorage.kontrakKuantitas = this.kuantitas,
      localStorage.kontrakUnitKuantitas = this.unitKuantitas,
      localStorage.kontrakKualitas = this.kualitas,
      localStorage.kontrakHargaKomoditas = this.hargaKomoditas,
      localStorage.kontrakTempatPembayaran = this.tempatPembayaran,
      localStorage.kontrakMusim = this.musim,
      localStorage.kontrakJalurPengiriman = this.jalurPengiriman,
      localStorage.kontrakSkalaPembayaran = this.skalaPembayaran,
      localStorage.kontrakBatasTanggalPembayaran = moment(this.batasTanggalPembayaran).format('DD-MM-YYYY'),
      localStorage.kontrakBatasWaktuPembayaran = this.batasWaktuPembayaran,
      localStorage.kontrakToleransi = this.toleransi,
      localStorage.kontrakDaerahPemasaran = this.daerahPemasaran,
      localStorage.kontrakProvinsiPemasaran = this.provinsiPemasaran,

      // Rincian Pengiriman
      localStorage.kontrakPengirim = this.pengirim,
      localStorage.kontrakLokasiPenjemputan = this.lokasiPenjemputan,
      localStorage.kontrakKontakPengirim = this.kontakPengirim,
      localStorage.kontrakAlamatJalanPenjemputan = this.alamatJalanPenjemputan,
      localStorage.kontrakAlamatKelurahanPenjemputan = this.alamatKelurahanPenjemputan,
      localStorage.kontrakAlamatKecamatanPenjemputan = this.alamatKecamatanPenjemputan,
      localStorage.kontrakAlamatKabupatenPenjemputan = this.alamatKabupatenPenjemputan,
      localStorage.kontrakAlamatKotaPenjemputan = this.alamatKotaPenjemputan,
      localStorage.kontrakAlamatProvinsiPenjemputan = this.alamatProvinsiPenjemputan,
      localStorage.kontrakAlamatKodePosPenjemputan = this.alamatKodePosPenjemputan,

      localStorage.kontrakPenerima = this.penerima,
      localStorage.kontrakLokasiPengiriman = this.lokasiPengiriman,
      localStorage.kontrakKontakPenerima = this.kontakPenerima,
      localStorage.kontrakAlamatJalanPengiriman = this.alamatJalanPengiriman,
      localStorage.kontrakAlamatKelurahanPengiriman = this.alamatKelurahanPengiriman,
      localStorage.kontrakAlamatKecamatanPengiriman = this.alamatKecamatanPengiriman,
      localStorage.kontrakAlamatKabupatenPengiriman = this.alamatKabupatenPengiriman,
      localStorage.kontrakAlamatKotaPengiriman = this.alamatKotaPengiriman,
      localStorage.kontrakAlamatProvinsiPengiriman = this.alamatProvinsiPengiriman,
      localStorage.kontrakAlamatKodePosPengiriman = this.alamatKodePosPengiriman,


      // Detail Pengiriman
      localStorage.kontrakTanggalMulaiPengiriman = moment(this.tanggalMulaiPengiriman).format('DD-MM-YYYY'),
      localStorage.kontrakWaktuMulaiPengiriman = this.waktuMulaiPengiriman,
      localStorage.kontrakTanggalBerakhirPengiriman = moment(this.tanggalBerakhirPengiriman).format('DD-MM-YYYY'),
      localStorage.kontrakWaktuBerakhirPengiriman = this.waktuBerakhirPengiriman,

      // Penjelasan Barang
      localStorage.kontrakJenisPengepakan = this.jenisPengepakan,

      // Kondisi Kontrak
      localStorage.kontrakKondisiUmum = this.kondisiUmum,
      localStorage.kontrakKondisiKhusus = this.kondisiKhusus,

      // Penilaian Kontrak
      localStorage.kontrakNilai = this.nilai,
      localStorage.kontrakMaxNilai = this.maxNilai,
      localStorage.kontrakTanggalJatuhTempo = moment(this.tanggalJatuhTempo).format('DD-MM-YYYY'),
      localStorage.kontrakWaktuJatuhTempo = this.waktuJatuhTempo,

      // Usaha Pedagang Perantara
      localStorage.kontrakJenisPembayaran = this.jenisPembayaran,

      // Administrasi
      localStorage.kontrakInvoicing = this.invoicing,
      localStorage.kontrakPerantara = this.perantara,
      localStorage.kontrakEntitasPerantara = this.entitasPerantara,
      localStorage.kontrakKontakPerantara = this.kontakPerantara,
      localStorage.kontrakCatatanPedagang = this.catatanPedagang

      // Sistem
      localStorage.kontrakActiveCurrentDate = moment().format('DD-MM-YYYY');

      window.getApp.$emit('APP_ULAS_KONTRAK');

    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
